import React from "react";
import loadable from "@loadable/component";
import { Container, Divider } from "@atoms";
import { Share, HeadingWIcon } from "@molecules";
import classNames from "classnames";
import _brand from "@utils/brand";

const PressGrid = loadable(() => import("@organisms/PressGrid"));
const WritingsGrid = loadable(() => import("@organisms/WritingsGrid"));
const VideoAudioGrid = loadable(() => import("@organisms/VideoAudioGrid"));

const ResourcesPage = ({ data, className, light }) => {
  const { hero, videoAudio, writings, press, url } = data;

  // const [, dispatch] = useAppState();

  // useEffect(() => {
  //   dispatch({ type: "setThemeLight" });
  // }, []);

  const { brand, romero, lakota, lgca } = _brand;

  const headingStyles = {
    romero: { heading: "text-blue", text: "text-black" },
    lakota: { heading: "text-black", text: "text-black" },
    lgca: { heading: "text-orange", text: "text-black" },
  }[brand];

  // blog state
  return (
    <div className={className}>
      {/* hero */}
      <div className={classNames("pt-40 lg:pt-48", { "bg-blue": lgca })}>
        <Container>
          <div className="grid grid-cols-1 items-end gap-0 md:grid-cols-3 md:gap-16">
            <div className="md:col-span-2">
              <HeadingWIcon
                icon="sunrise"
                {...hero}
                colors={
                  lgca
                    ? { heading: "text-orange", text: "text-white" }
                    : headingStyles
                }
              />
              <Divider />
            </div>
            <div className="w-full md:col-span-1">
              <Share url={url} small light={light} />
              <Divider />
            </div>
          </div>
        </Container>
      </div>
      {lgca && (
        <WritingsGrid
          data={writings}
          headingStyles={headingStyles}
          className={classNames("bg-near-white py-16", {
            "order-3": romero,
            "order-2": lakota,
          })}
        />
      )}
      <VideoAudioGrid
        data={videoAudio}
        headingStyles={headingStyles}
        className={classNames("bg-transparent py-16", {
          "order-3": romero,
          "order-2": lakota,
        })}
      />
      {romero && (
        <PressGrid
          data={press}
          headingStyles={headingStyles}
          className={classNames("bg-white py-16", {
            "order-3": romero,
            "order-2": lakota,
          })}
        />
      )}
      {!lgca && (
        <WritingsGrid
          data={writings}
          headingStyles={headingStyles}
          className={classNames("bg-near-white py-16", {
            "order-3": romero,
            "order-2": lakota,
          })}
        />
      )}
      {!!press?.documents?.length && (lakota || lgca) && (
        <PressGrid
          data={press}
          headingStyles={headingStyles}
          className={classNames("bg-white py-16", {
            "order-3": romero,
            "order-2": lakota,
          })}
        />
      )}
    </div>
  );
};

ResourcesPage.defaultProps = {};

export default ResourcesPage;
